import PixelContentMock from './PixelContentMock';
export default PixelContentMock;